export const watchvideo = [
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  },
  {
    video: {
      name: 'Video de YouTube',
      url: 'https://www.youtube.com/embed/XXnOxB_cCdE?autoplay=1'
    },
    image: {
      name: 'Maria Simon',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    description: 'BASYS Sistema administrativo de basculas camionras, control de inventarios materiales reciclados'
  }
]
